import Vue from 'vue';

function clearUser(state) {
	Vue.set(state, 'token', null);
}

function setToken(state, token) {
	Vue.set(state, 'token', token);
}

function showSnackBar(state, snackbar) {
	Vue.set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	Vue.set(state.appConfig, 'isLoading', value);
}

const methods = {
	clearUser,
	setToken,
	showSnackBar,
	toggleLoading,
};

export default methods;



// WEBPACK FOOTER //
// ./src/store/mutations.js